module.exports = __webpack_public_path__ + "img/perfil.a9055890.jpg";